require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Lib1ThemeBuild/Platforms/1804Build/~/core-js/modules/es7.symbol.async-iterator.js
// module id = 666
// module chunks = 8